import { createFileRoute } from "@tanstack/react-router";
import { SyncSourceShellPage } from "./-syncs/sync-ops.pages";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/syncs/$sourceId")({
  component: SyncSourceShellPage,
});
